import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import Vue from 'vue'
import VueApollo from 'vue-apollo'
import fetch from 'unfetch'
import { ApolloLink as ApolloLinkBase, Observable } from 'apollo-link'

Vue.use(VueApollo)

const uri = `${process.env.VUE_APP_SERVER_URL}/graphql`

const CACHE_TTL = 10 * 60 * 1000 // 10 minutes in milliseconds

// Sales data must always come from the API, including previously cached zeroes.
// Event details contain capacity, dates and ticketing settings, so they are live too.
const queriesToCache = [
  'getEventAdditionalDataForRegisterContainer',
  'getLanguageCodesForEvent',
]

const cacheLink = new ApolloLinkBase((operation, forward) => {
  const { operationName, variables = {}, query } = operation
  // Fail closed for combined/fragment queries: a static operation name must not
  // make a response containing inventory cacheable.
  const definition = query.definitions.length === 1 && query.definitions[0]
  const selections = definition && definition.selectionSet && definition.selectionSet.selections
  const cacheable = queriesToCache.includes(operationName) &&
    definition.kind === 'OperationDefinition' && definition.operation === 'query' &&
    selections.length === 1 && selections[0].kind === 'Field' &&
    selections[0].name.value === operationName && !selections[0].alias

  let slug = variables.slug
  try {
    slug = slug || window.localStorage.getItem(`redirect:${variables.eventId}`)
    if (slug) {
      const key = `${operationName}:${slug}`
      if (!cacheable) {
        // Remove old availability entries when encountered after an upgrade.
        window.localStorage.removeItem(key)
      } else {
        const cachedRaw = window.localStorage.getItem(key)
        if (cachedRaw) {
          const { timestamp, data } = JSON.parse(cachedRaw)
          if (Date.now() - timestamp < CACHE_TTL) {
            return Observable.of({ data })
          }
          window.localStorage.removeItem(key)
        }
      }
    }
  } catch (error) {
    // Unavailable browser storage must never prevent a fresh availability read.
  }

  if (!cacheable) return forward(operation)

  return forward(operation).map(response => {
    if (!response.errors && response.data) {
      const event = response.data.getEventAdditionalDataForRegisterContainer
      const canonicalSlug = (event && event.slug) || slug
      if (canonicalSlug) {
        try {
          window.localStorage.setItem(
            `${operationName}:${canonicalSlug}`,
            JSON.stringify({ timestamp: Date.now(), data: response.data }),
          )
        } catch (error) {
          // Caching is optional when browser storage is unavailable or full.
        }
      }
    }

    return response
  })
})

const httpLink = new HttpLink({ uri, fetch, credentials: 'include' })

const link = ApolloLink.from([cacheLink, httpLink])

const cache = new InMemoryCache({
  addTypename: true,
})

// persistCache({
//   cache,
//   storage: window.localStorage,
// })

export const apolloClient = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: { fetchPolicy: 'no-cache', errorPolicy: 'ignore' },
    query: { fetchPolicy: 'no-cache', errorPolicy: 'all' },
    mutate: {
      errorPolicy: 'all',
    },
  },
})

export default new VueApollo({
  defaultClient: apolloClient,
})
